import { render, staticRenderFns } from "./o-capabilities.vue?vue&type=template&id=e5c65cb6"
import script from "./o-capabilities.vue?vue&type=script&lang=js"
export * from "./o-capabilities.vue?vue&type=script&lang=js"
import style0 from "./o-capabilities.vue?vue&type=style&index=0&id=e5c65cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports